/**
 * General utility functions
 */

/**
 * Convert US state code to full state name
 */
export function getStateName(stateCode: string): string {
  const stateMap: Record<string, string> = {
    'AL': 'Alabama',
    'AK': 'Alaska',
    'AZ': 'Arizona',
    'AR': 'Arkansas',
    'CA': 'California',
    'CO': 'Colorado',
    'CT': 'Connecticut',
    'DE': 'Delaware',
    'FL': 'Florida',
    'GA': 'Georgia',
    'HI': 'Hawaii',
    'ID': 'Idaho',
    'IL': 'Illinois',
    'IN': 'Indiana',
    'IA': 'Iowa',
    'KS': 'Kansas',
    'KY': 'Kentucky',
    'LA': 'Louisiana',
    'ME': 'Maine',
    'MD': 'Maryland',
    'MA': 'Massachusetts',
    'MI': 'Michigan',
    'MN': 'Minnesota',
    'MS': 'Mississippi',
    'MO': 'Missouri',
    'MT': 'Montana',
    'NE': 'Nebraska',
    'NV': 'Nevada',
    'NH': 'New Hampshire',
    'NJ': 'New Jersey',
    'NM': 'New Mexico',
    'NY': 'New York',
    'NC': 'North Carolina',
    'ND': 'North Dakota',
    'OH': 'Ohio',
    'OK': 'Oklahoma',
    'OR': 'Oregon',
    'PA': 'Pennsylvania',
    'RI': 'Rhode Island',
    'SC': 'South Carolina',
    'SD': 'South Dakota',
    'TN': 'Tennessee',
    'TX': 'Texas',
    'UT': 'Utah',
    'VT': 'Vermont',
    'VA': 'Virginia',
    'WA': 'Washington',
    'WV': 'West Virginia',
    'WI': 'Wisconsin',
    'WY': 'Wyoming',
    'DC': 'District of Columbia'
  };

  return stateMap[stateCode.toUpperCase()] || stateCode;
}

/**
 * Format ghost tier to standard display format
 */
export function formatGhostTierDisplay(tier: string | number | undefined | null): string {
  if (tier === undefined || tier === null || tier === '') return '';
  const tierStr = String(tier).toLowerCase();
  
  if (tierStr.includes('junior') || tierStr === '0') return 'Tier 3 (Junior)';
  if (tierStr.includes('senior') || tierStr === '1') return 'Tier 2 (Senior)';
  if (tierStr.includes('elite') || tierStr === '2') return 'Tier 1 (Elite)';
  if (tierStr === 'all tiers') return 'All Tiers';
  
  return String(tier);
}

/**
 * Get a privacy-safe display name for business users.
 * Only Call Sign is allowed to be shown; otherwise use a generic role label.
 */
export function getCallSignDisplayName(
  callSign: string | undefined | null,
  fallbackLabel: string
): string {
  const normalizedCallSign = callSign?.trim();

  return normalizedCallSign || fallbackLabel;
}
